import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-toast-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss', '../../app.component.scss']
})
export class ToastMessageComponent implements OnInit{
  public statusMessage: string = "";
  public statusType: string = "";


  ngOnInit(): void {
    
  }

  showToast(statusMessage: string, statusType: string, timeout: number = 0){
    this.statusMessage = statusMessage;
    this.statusType = statusType;

    const toastContainer = document.getElementById('toast-wrapper');

    setTimeout(function() {
      toastContainer.classList.add('show');
    }, 100);

    if (timeout !== 0) {
      setTimeout(function() {
        toastContainer.classList.remove('show');
      }, timeout);
    }
  }
}
